module.exports = __webpack_public_path__ + "img/banner02_info_S_1.87082e92.svg";